import React from 'react';
import MemberSpecial from './MemberSpecial';

const Professionals = (props: any) => <MemberSpecial {...props} />;

export default Professionals;
